// SPAC-2771: protection against reload/redirect loops between account slots.
// Automatic navigations (sign-out reload, slot redirects in `App` / `Auth`) are counted per browser tab
// in `sessionStorage`, which survives reloads and same-origin navigations of this tab.
// Once the limit is reached, callers must stay on the current page instead of navigating.

const STORAGE_KEY = 'tt-auto-navigations';
export const AUTO_NAVIGATION_WINDOW_MS = 30000;
export const AUTO_NAVIGATION_MAX_COUNT = 5;

function readTimestamps(now: number): number[] {
  try {
    const parsed = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '[]');
    return Array.isArray(parsed)
      ? parsed.filter((ts): ts is number => typeof ts === 'number' && ts <= now && now - ts < AUTO_NAVIGATION_WINDOW_MS)
      : [];
  } catch (err) {
    return [];
  }
}

/**
 * Registers an automatic navigation and returns `true` if it is allowed.
 * Returns `false` (and registers nothing) when there were too many of them recently: probably a loop.
 */
export function registerAutoNavigation(now = Date.now()) {
  const timestamps = readTimestamps(now);
  if (timestamps.length >= AUTO_NAVIGATION_MAX_COUNT) {
    // eslint-disable-next-line no-console
    console.warn('[autoNavigationGuard] Too many automatic navigations, staying on the current page');
    return false;
  }

  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify([...timestamps, now]));
  } catch (err) {
    // Storage is unavailable: don't block navigation
  }

  return true;
}
